/**
 * Timing knobs for Clerk session refresh, the reconnecting
 * indicator, and visibility-driven recovery. Tune here — feature code
 * imports these instead of embedding literals.
 */
export const CLERK_SESSION_REFRESH_TIMING = {
  /** Default max wait per `refreshClerkSession` caller. */
  callerBoundMs: 5_000,
  /**
   * Log a hung `getToken` only after this (default). Callers unblock at
   * `callerBoundMs` (or the hidden-scaled bound below). Raised from 30s
   * after PORTAL-1AA: wake/reconnect refreshes often settle as
   * `refreshed` in the 30–45s window (staging saw 34s) — paging at 30s
   * was the same false-positive class as PORTAL-JA at the old 4s bound.
   */
  hangLogMs: 60_000,
  /**
   * Hang-log thresholds after a long-hidden tab or an `online`
   * reconnect. Network + Clerk FAPI recovery after sleep routinely
   * exceeds the default hang window without being a true hang.
   */
  hangLogAfterHiddenMs: {
    medium: 60_000,
    long: 90_000,
  },
  /** Hang-log wait when the refresh was triggered by `online`. */
  hangLogAfterOnlineMs: 90_000,
  /** Tab hidden at least this long → `callerBoundAfterHiddenMs.medium`. */
  hiddenDurationThresholdMs: {
    medium: 60 * 1000,
    long: 5 * 60 * 1000,
  },
  /** Caller-bound timeout when `hiddenDurationMs` crosses a threshold. */
  callerBoundAfterHiddenMs: {
    medium: 8_000,
    long: 12_000,
  },
  indicator: {
    /** Below this, successful refreshes never show the banner. */
    showRefreshingAfterMs: 750,
    /** Auto-clear sticky `failed` UI after a one-off blip. */
    autoClearFailedAfterMs: 5_000,
  },
} as const;
